import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=a8b235c6&scoped=true&"
import script from "./CoursesList.vue?vue&type=script&lang=js&"
export * from "./CoursesList.vue?vue&type=script&lang=js&"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=a8b235c6&lang=scss&scoped=true&"
import style1 from "./CoursesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b235c6",
  null
  
)

export default component.exports